import React, { useEffect, useState } from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import "./enquiry.css";
import EnquirySummaryCard from "./EnquirySummaryCard";
import TimestampConverter from "../../utils/TimestampConverter";
import { getApi, patchEnquiry } from "../../actions/structure.action";
import { getUserBussinessInfomation, getUserCompanyInfo } from "../../actions/user.actions";
import isEmpty from "../../utils/is-Empty";
import { stringConstants } from "../../helpers";

const EnquiryDetails = ({ id, currentEnquiry }) => {
  const dispatch = useDispatch();
  const [sellerCompanyInfo, setSellerCompanyInfo] = useState(null);
  const { sellerAddress, buyerAddress, userBussinessInfomation, auth } = useSelector(
    (state) => state
  );

  useEffect(() => {
    // console.log("CURRENT ENQUIRY: ", currentEnquiry);
    if (!isEmpty(currentEnquiry?.seller_id)) {
      getApi("getSellerAddress", dispatch, "/" + currentEnquiry?.seller_id);

      getUserCompanyInfo(currentEnquiry?.seller_id, dispatch).then((res) => {
        // console.log("SELLER COMPANY INFO: ", res);
        if (res.success) {
          setSellerCompanyInfo(res.data);
        }
      });
    }
    if (!isEmpty(currentEnquiry?.buyer_id)) {
      getApi("getBuyerAddress", dispatch, "/" + currentEnquiry?.buyer_id);
      getUserBussinessInfomation(currentEnquiry?.buyer_id, dispatch);
    }
  }, [currentEnquiry, dispatch]);

  const acceptEnquiryStatus = (enquiryPkId) => {
    let sendObj = {};
    sendObj["id"] = enquiryPkId;
    sendObj["enquiry_status"] = "accepted";
    patchEnquiry(sendObj, dispatch);
  };

  return (
    <>
      <div className="order-section-title-div mt-2">
        <h4 className="order-section-title m-0">{"Enquiry Details"}</h4>
      </div>
      <div id="borderLeft"></div>
      <Row className="m-0 py-2 order-info">
        <Col xs={12} sm={12} md={8} lg={8} className="p-0 text-start">
          <div>
            <p className="m-0">
              Enquiry ID: <span># {currentEnquiry?.enquiry_id}</span>
            </p>
          </div>
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} className="p-0 left-col">
          <div>
            <p className="m-0">
              Enquiry Date: <span>{TimestampConverter(currentEnquiry?.enquiryCreatedAt)}</span>
            </p>
          </div>
        </Col>
      </Row>
      <Row className="m-0 py-2">
        <Col xs={12} sm={12} md={8} lg={8} className="p-0">
          <EnquirySummaryCard card={currentEnquiry} />
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} className="p-0 left-col">
          <div>
            <p className="m-0">
              <strong>Enquiry Status:</strong>{" "}
              <span className="text-uppercase">{currentEnquiry?.enquiry_status}</span>
            </p>
          </div>
          {currentEnquiry?.accepted_at && (
            <div>
              <p className="m-0">
                <strong>Accepted Date:</strong>{" "}
                <span>{TimestampConverter(currentEnquiry?.accepted_at)}</span>
              </p>
            </div>
          )}
        </Col>
      </Row>
      <Row className="m-0 py-2">
        <Col xs={12} sm={12} md={6} lg={6} className="p-0 text-start">
          <div>
            <span className="order-section-title m-0 text-start" style={{ fontSize: "1.2rem" }}>
              <strong>{"Delivery Address"}</strong>
            </span>
          </div>
          <div id="borderLeft"></div>
          <div className="mt-1 text-start">
            <p className="m-0">{userBussinessInfomation?.data?.business_name}</p>
            <p className="m-0 small">
              {buyerAddress?.data?.address_line_1}
              {!isEmpty(buyerAddress?.data?.address_line_2)
                ? ", " + buyerAddress?.data?.address_line_2
                : ""}
              {!isEmpty(buyerAddress?.data?.address_line_3)
                ? ", " + buyerAddress?.data?.address_line_3
                : ""}
              <br />
              {"City: " + buyerAddress?.data?.city}
              <br />
              {"State: " + buyerAddress?.data?.state}
              <br />
              {"Country: " + buyerAddress?.data?.country}
            </p>
            <p className="m-0 small">Pin code: {buyerAddress?.data?.pin_code}</p>
            <p className="m-0 small">Contact: {buyerAddress?.data?.primary_number}</p>
            <p className="m-0 small">
              Contact Person:{" "}
              {userBussinessInfomation?.data?.contact_person_name
                ? userBussinessInfomation?.data?.contact_person_name
                : "--"}
            </p>
            <p className="m-0 small">
              Email:{" "}
              {userBussinessInfomation?.data?.email ? userBussinessInfomation?.data?.email : "--"}
            </p>
            <p className="m-0 small">
              GST:{" "}
              {userBussinessInfomation?.data?.gst_no ? userBussinessInfomation?.data?.gst_no : "--"}
            </p>
          </div>
        </Col>

        {auth?.loggedIn && auth?.user?.role?.role_name === stringConstants.ROLL_BHAREE && (
          <Col xs={12} sm={12} md={6} lg={6} className="p-0 text-start">
            <div>
              <span className="order-section-title m-0 text-start" style={{ fontSize: "1.2rem" }}>
                <strong>{`Seller Address`}</strong>
              </span>
            </div>
            <div id="borderLeft"></div>
            <div className="mt-1 text-start">
              <p className="m-0">{sellerCompanyInfo?.business_info?.business_name}</p>
              <p className="m-0 small">
                {sellerAddress?.data?.address_line_1}
                {!isEmpty(sellerAddress?.data?.address_line_2)
                  ? ", " + sellerAddress?.data?.address_line_2
                  : ""}
                {!isEmpty(sellerAddress?.data?.address_line_3)
                  ? ", " + sellerAddress?.data?.address_line_3
                  : ""}
                <br />
                {"City: " + sellerAddress?.data?.city}
                <br />
                {"State: " + sellerAddress?.data?.state}
                <br />
                {"Country: " + sellerAddress?.data?.country}
              </p>
              <p className="m-0 small">Pin code: {sellerAddress?.data?.pin_code}</p>
              <p className="m-0 small">Contact: {sellerCompanyInfo?.mobile_number}</p>
              <p className="m-0 small">Contact Person: {sellerCompanyInfo?.contact_person_name}</p>
              <p className="m-0 small">Email: {sellerCompanyInfo?.email}</p>
              <p className="m-0 small">GST: {sellerCompanyInfo?.business_info?.gst_no}</p>
            </div>
          </Col>
        )}

        <Col
          xs={12}
          sm={12}
          md={6}
          lg={6}
          className="p-0 d-flex flex-column justify-content-end text-end"
        >
          {!isEmpty(currentEnquiry) && currentEnquiry?.enquiry_status === "pending" && (
            <div className="order-main-section">
              <Button
                variant="primary"
                className="accept action-button"
                onClick={() => {
                  acceptEnquiryStatus(currentEnquiry?.enquiry_pk_id);
                }}
              >
                <i class="bi bi-check"></i> Accept Enquiry
              </Button>
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};

export default EnquiryDetails;
